import { Link, NavLink, useNavigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../auth/AuthContext';

export default function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const linkCls = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 rounded-md text-sm font-medium ${
      isActive ? 'bg-brand-50 text-brand-700' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
    }`;

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white border-b border-slate-200">
        <div className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold text-brand-700">Fiş Takip</Link>
          <nav className="flex items-center gap-1">
            {user?.role === 'employee' && (
              <>
                <NavLink to="/fisler" className={linkCls}>Fişlerim</NavLink>
                <NavLink to="/fisler/yeni" className={linkCls}>Yeni Fiş</NavLink>
              </>
            )}
            {user?.role === 'admin' && (
              <>
                <NavLink to="/yonetim/donemler" className={linkCls}>Dönemler</NavLink>
                <NavLink to="/yonetim/excel" className={linkCls}>Excel Raporu</NavLink>
              </>
            )}
          </nav>
          <div className="flex items-center gap-3">
            <span className="text-sm text-slate-600">{user?.name}</span>
            <button
              onClick={() => {
                logout();
                nav('/giris');
              }}
              className="btn-secondary"
            >
              Çıkış
            </button>
          </div>
        </div>
      </header>
      <main className="flex-1 mx-auto w-full max-w-6xl px-4 py-6">{children}</main>
      <footer className="text-center text-xs text-slate-500 py-4">
        © {new Date().getFullYear()} Fiş Takip
      </footer>
    </div>
  );
}
